import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api from "../lib/api";
import { Button } from "./ui/button";

/**
 * Shared submit handler for the dedicated request pages.
 * Each dedicated page composes its own field UI and hands us its payload.
 * We attach `source` so admin can differentiate request type in the dashboard.
 */
export function SubmitBar({ payload, source, submitLabel, redirectTo = "/thank-you", extraData = {}, className = "" }) {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const endpoint =
  source === "maintenance"
    ? "/maintenance"
    : "/quotations";

await api.post(endpoint, {
  ...payload,
  ...extraData,
  source,
});
      navigate(`${redirectTo}?type=${source}`);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleSubmit}
      disabled={submitting}
      data-testid={`submit-${source}`}
      className={`bg-[#ef4444] hover:bg-[#dc2626] text-white font-semibold h-12 px-8 ${className}`}
    >
      {submitting ? "..." : submitLabel}
      {!submitting && <Send className="w-4 h-4 ms-2" />}
    </Button>
  );
}
